import React, { useEffect, useState } from 'react'
import { Empty } from 'antd'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import 'src/Pages/LibraryPages/librarypages.scss'

const ProgressReportDetail = () => {
  const { reportId } = useParams()
  const navigate = useNavigate()
  const [report, setReport] = useState(null)
  const [loading, setLoading] = useState(true)
  const token = localStorage.getItem('token')

  const fetchStatusReport = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/InternshipStatusReport/${reportId}`,
        {
          headers: {
            Accept: '*/*',
            Authorization: `Bearer ${token}`,
          },
        },
      )
      setReport(response.data)
    } catch (error) {
      console.error('Error fetching report:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (reportId) {
      fetchStatusReport()
    }
  }, [reportId])

  return (
    <div className="lpg">
      <style>{`
        .prd-sect__title { display:flex; align-items:center; gap:9px; margin:0 0 18px;
          color:#16233f; font-size:1.1rem; font-weight:800; letter-spacing:-0.01em; line-height:1.2; }
        .prd-sect__title::before { content:''; flex:none; width:4px; height:20px; border-radius:999px;
          background:linear-gradient(180deg,#3b82f6,#2563eb); }
        .prd-kv { display:grid; grid-template-columns:max-content 1fr; gap:12px 20px; margin-bottom:20px; }
        .prd-kv__k { color:#6b7794; font-size:0.75rem; font-weight:700; text-transform:uppercase;
          letter-spacing:0.05em; padding-top:2px; }
        .prd-kv__v { color:#16233f; font-size:0.92rem; line-height:1.55; }
        .prd-desc { margin-top:4px; padding-top:18px; border-top:1px solid #eef1f6; }
        .prd-desc__title { margin:0 0 8px; color:#6b7794; font-size:0.75rem; font-weight:700;
          text-transform:uppercase; letter-spacing:0.05em; }
        .prd-desc__body { margin:0; color:#16233f; font-size:0.92rem; line-height:1.65; white-space:pre-wrap; }
        .prd-meta { margin-top:18px; padding-top:14px; border-top:1px solid #eef1f6;
          color:#6b7794; font-size:0.8rem; }
        @media (max-width:560px){
          .prd-kv { grid-template-columns:1fr; gap:4px 0; }
          .prd-kv__k { margin-top:10px; }
          .prd-kv__k:first-child { margin-top:0; }
        }
      `}</style>

      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <path d="M14 2v6h6M9 13h6M9 17h4" />
            </svg>
          </span>
          <div>
            <h1 className="lpg__title">Progress Report Detail</h1>
            <p className="lpg__sub">Report details.</p>
          </div>
        </div>
        <button type="button" className="lpg__back" onClick={() => navigate(-1)}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M11 18l-6-6 6-6" />
          </svg>{' '}
          Back
        </button>
      </div>

      {loading ? (
        <div className="lpg__state">
          <div className="lpg__spin" />
          Loading...
        </div>
      ) : (
        <div className="lpg__panel-box">
          {report ? (
            <>
              <h2 className="prd-sect__title">Week {report.weekNumber}</h2>

              <div className="prd-kv">
                <span className="prd-kv__k">Project Name</span>
                <span className="prd-kv__v">{report.projectName || 'N/A'}</span>

                <span className="prd-kv__k">Group Name</span>
                <span className="prd-kv__v">{report.groupName || 'N/A'}</span>

                <span className="prd-kv__k">Student Name</span>
                <span className="prd-kv__v">{report.studentName || 'N/A'}</span>
              </div>

              <div className="prd-desc">
                <p className="prd-desc__title">Description</p>
                <p className="prd-desc__body">{report.reportText || 'N/A'}</p>
              </div>

              <div className="prd-meta">
                Submitted on:{' '}
                {report.submissionDate
                  ? new Date(report.submissionDate).toLocaleDateString()
                  : 'N/A'}
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '50px 0' }}>
              <Empty description="No report found" />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default ProgressReportDetail
